<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">DATA REKERNING</h6>
     
        <b-button variant="pgiBtn" class="mr-2 mb-2" name="anggotaEditBtn"  @click="showModalInput"><i class="fa fa-plus"></i> Tambah Rekening</b-button>
        <b-table bordered hover show-empty
                :busy="isBusy"
                :items="rekening"
                :currentPage="currentPage" 
                :fields="fields" 
                :perPage="perPage"
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data rekening anggota.
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge v-if=" row.item.status == 0 " variant="danger">Non - Aktif</b-badge>
                    <b-badge v-if=" row.item.status == 1 " variant="success">Active</b-badge>
                    <b-badge v-if=" row.item.status == 2 " variant="warning">Pending</b-badge>
                </template>
                <template v-slot:cell(aksi)="row">
                    <div class="no-wrap">
                        <!-- {{ row.item }} -->
                        <div v-if="row.item.status == 1">
                            <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit"
                                name="jenisBarangHapusBtn" @click="showModalEdit(row.item)">
                                        <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                            <b-button v-if="role == 'Super Admin' && name == 'Anditha'" size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="non-aktif"
                                name="jenisBarangHapusBtn" @click="showModalNonAktif(`${row.item.id}`)">
                                <i class="fa fa-minus-square-o text-danger"></i>
                            </b-button>
                        </div>
                        <div v-if="role == 'Super Admin' && name == 'Anditha' && row.item.status == 0">
                            <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Aktifkan"
                                name="jenisBarangHapusBtn" @click="showModalAktif(row.item.id)">
                                        <i class="fa fa-plus"></i>
                            </b-button>
                        </div>
                        <b-button v-if="role == 'Super Admin'  && name == 'Anditha' && row.item.status == 2" size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Terima Edit"
                            name="jenisBarangHapusBtn" @click="showApproveEdit(`${row.item.id}`)">
                            <i class="fa fa-check"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group class="align-items-center tableShowItem">
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>

            <!-- -----------  MODAL INPUT  ----------- -->
            <b-modal id="modal-tambah-rek" title="Tambah Rekening">
                <b-form-group label="Bank">
                    <multiselect v-model="inputForm.bank" :options="optionsBank" :internal-search="true"
                        :allow-empty="false" label="name" track-by="id"
                        placeholder="-- Pilih Bank --" />
                </b-form-group>

                <b-form-group label="No Rekening">
                        <b-form-input
                        v-model="inputForm.noRek"
                        placeholder="Masukan No. Rekening"
                        required
                        @keyup="noRek()"
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Email Nasabah"
                description="Gunakan 'Pugindo@gmail.com' jika nasabah tidak memiliki email">
                        <b-form-input
                        v-model="inputForm.email"
                        placeholder="Masukan Email Nasabah"
                        type="email"
                        required
                        ></b-form-input>
                </b-form-group>
           
                <b-form-group label="Nama a / n Bank" :hidden="inputForm.anBank == null ?true :false">
                        <b-form-input
                        v-model="inputForm.anBank"
                        placeholder="Masukan a / n Bank"
                        readonly
                        required
                        ></b-form-input>
                </b-form-group>

                <template v-slot:modal-footer="{ ok }">

                    <b-button variant="primary" name="submitBtn" @click="cekRekening" :disabled="isSubmitting">
                        {{ isSubmitting ? "Sedang Mengecek..." : "Cek Rekening" }}
                    </b-button>

                    <b-button variant="primary" name="submitBtn" @click="confirmSubmit" :disabled="submit">
                        Submit
                    </b-button>
                </template>
            </b-modal>

            <!-- -----------  MODAL Edit  ----------- -->
            <b-modal id="modal-edit-rek" title="Edit Rekening">
                <b-form-group label="Bank">
                    <multiselect v-model="inputForm.bank" :options="optionsBank" :internal-search="true"
                        :allow-empty="false" label="name" track-by="id"
                        placeholder="-- Pilih Bank --" />
                </b-form-group>

                <b-form-group label="No Rekening">
                        <b-form-input
                        v-model="inputForm.noRek"
                        placeholder="Masukan No. Rekening"
                        required
                        @keyup="noRek()"
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Email Nasabah"
                description="Gunakan 'Pugindo@gmail.com' jika nasabah tidak memiliki email">
                        <b-form-input
                        v-model="inputForm.email"
                        placeholder="Masukan Email Nasabah"
                        required
                        type="email"
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Nama a / n Bank" :hidden="inputForm.anBank == null ?true :false">
                        <b-form-input
                        v-model="inputForm.anBank"
                        placeholder="Masukan a / n Bank"
                        readonly
                        required
                        ></b-form-input>
                </b-form-group>

                <template v-slot:modal-footer="{ ok }">

                    <b-button variant="primary" name="submitBtn" @click="cekRekening" :disabled="isSubmitting">
                        {{ isSubmitting ? "Sedang Mengecek..." : "Cek Rekening" }}
                    </b-button>

                    <b-button variant="primary" name="submitBtn" @click="confirmEdit" :disabled="submit">
                        Submit
                    </b-button>
                </template>
            </b-modal>

            <ModalConfirm id="modal-confirm-input" title="Confirm Input No. Rekening" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk input No. Rekening ini ?" @submit="onSubmit" />

            <ModalConfirm id="modal-aktif" title="Confirm Aktif Rekening" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk mengaktifkan Rekening ini ?" @submit="aktif" />

            <ModalConfirm id="modal-confirm-edit-rekening" title="Confirm Edit No. Rekening" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk Edit No. Rekening ini ?" @submit="onSubmitEdit" />

            <ModalConfirm id="modal-non-aktif" title="Confirm Hapus Rekening" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk menon-aktifkan Rekening ini?" @submit="nonAktif" />

            <ModalConfirm id="modal-approve-edit" title="Approve Edit Rekening" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk Menyetujui Perubahan rekening ini?" @submit="approveEditRekening" />

    </div>
</template>

<script>
export default {
    name: 'data-rekening',
    props: {
        id: { type: Number, required: true }
    },
    data(){
        return{
            isLoading: false,
            activeSearch: null,
            data: null,
            kota: [],

            //id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            activeId: null,
            role: null,
            name:null,

            rekening : [],
            fields: [
                { key: "no", label: "No"},
                { key: "namaBank", label: "Nama Bank"},
                { key: "noRekening", label: "No. Rekening"},
                { key: "namaRekening", label: "A/N Rekening"},
                { key: "status", label: "Status"},
                { key: "aksi", label: "Aksi"},
            ],

            input: {
                show: 10,
                filterName: null,
                filterNo: null,
                sortBy: null,
                sortDesc: null
            },

            inputForm:{
                id : null,
                bank : null,
                noRek : null,
                anBank : null,
                email: 'Pugindo@gmail.com'
            },

            optionsBank:[
                // { nama : "bca",value: 1},
                // { nama : "bri",value: 2},
                // { nama : "mandiri",value: 3},
                // { nama : "gopay",value: 4},
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",

            submit:true
        }
    },
    watch: {
        "dataAnggota.rtSekarang": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataAnggota.rtSekarang = result);
        },
        "dataAnggota.rwSekarang": function(newValue) {
            const result = newValue.replace(/[^\d]/g,'');
            this.$nextTick(() => this.dataAnggota.rwSekarang = result);
        },
    },
    methods: {
        //----------------- Fungsi Inisialisasi -----------------
        noRek(){
            let cleanValue = this.$helper.changeToValue(this.inputForm.noRek);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
            this.inputForm.noRek = result
        },

        init() {

            this.role = localStorage.getItem("role")
            this.name = localStorage.getItem("name")
            let getRekening = this.$axios.get("nasabah/list-rekening/" + this.id).then(response => {
                let datas = response.data
                let i = 1
                for(var data of datas){
                    this.rekening.push({
                        id : data.id,
                        no : i,
                        namaBank : data.namaBank,
                        noRekening : data.noRekening,
                        namaRekening : data.namaRekening,
                        email: (data.email != null)?data.email :'Pugindo@gmail.com',
                        status : data.status
                    })

                    i++
                }

                this.updateTotalItem(response.data.length)
            })

            let getBank = this.$axios.get("bank/list/").then(response => {
         
                this.optionsBank = response.data

            })

            Promise.all([getRekening,getBank]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        getRekening() {

            let getRekening = this.$axios.get("nasabah/list-rekening/" + this.id).then(response => {
                this.rekening = []
                let datas = response.data
                let i = 1
                for(var data of datas){
                    this.rekening.push({
                        id : data.id,
                        no : i,
                        namaBank : data.namaBank,
                        noRekening : data.noRekening,
                        namaRekening : data.namaRekening,
                        email: data.email,
                        status : data.status
                    })

                    i++
                }
                this.updateTotalItem(response.data.length)
            })

            Promise.all([getRekening]).then(() => {
                this.isBusy = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        cekRekening(){

            if(this.inputForm.bank == null){
                this.$helper.toastErr(this, "Mohon memilih bank terlebih dahulu!")
                return
            }
            if(this.inputForm.noRek == null || this.inputForm.noRek == ""){
                this.$helper.toastErr(this, "Mohon masukan No. Rekening terlebih dahulu!")
                return
            }

            this.isSubmitting = true

            let payload = new FormData
            payload.append("bank" , this.inputForm.bank.id)
            payload.append("rekening" , this.inputForm.noRek)
            this.$axios.post('midtrans/account_validation' , payload ).then(response => {
            
                if(response.status == 200){
                    if(response.data == "Tidak dapat menambah rekening yang sama"){
                        this.isSubmitting = false
                        this.$helper.toastErr(this, "Tidak dapat menambah rekening yang sama")
                        return
                    }else{
                        this.submit = false
                        this.isSubmitting = false
                        this.$helper.toastSucc(this, "No. Rekening Valid Silahkan Submit!")   
                        this.inputForm.anBank = response.data.account_name
                    }
                }
            }).catch(error => {
                console.log(error)
                this.submit = true
                this.isSubmitting = false
                this.$helper.toastErr(this, "No. Rekening Tidak Valid!")
                return
            })
        },

        confirmSubmit(){
            if(this.inputForm.bank == null){
                this.$helper.toastErr(this, "Mohon memilih bank terlebih dahulu!")
                return
            }
            if(this.inputForm.noRek == null || this.inputForm.noRek == ""){
                this.$helper.toastErr(this, "Mohon masukan No. Rekening terlebih dahulu!")
                return
            }
            if(this.inputForm.email == null || this.inputForm.email == ""){
                this.$helper.toastErr(this, "Mohon masukan Email Nasabah terlebih dahulu!")
                return
            }
            if(this.inputForm.anBank == null || this.inputForm.anBank == ""){
                this.$helper.toastErr(this, "Mohon masukan a / n Bank terlebih dahulu!")
                return
            }
            this.$bvModal.show("modal-confirm-input")
        },

        confirmEdit(){
        
            if(this.inputForm.bank == null){
                this.$helper.toastErr(this, "Mohon memilih bank terlebih dahulu!")
                return
            }
            if(this.inputForm.noRek == null || this.inputForm.noRek == ""){
                this.$helper.toastErr(this, "Mohon masukan No. Rekening terlebih dahulu!")
                return
            }
            if(this.inputForm.email == null || this.inputForm.email == ""){
                this.$helper.toastErr(this, "Mohon masukan Email Nasabah terlebih dahulu!")
                return
            }
            if(this.inputForm.anBank == null || this.inputForm.anBank == ""){
                this.$helper.toastErr(this, "Mohon masukan a / n Bank terlebih dahulu!")
                return
            }
            this.$bvModal.show("modal-confirm-edit-rekening")
        },

        onSubmit(){
            let payload = new FormData

            payload.append("namaRekening" , this.inputForm.anBank )
            payload.append("noRekening" , this.inputForm.noRek )
            payload.append("bank" , this.inputForm.bank.id )
            payload.append("nasabah" , this.id )
            payload.append("email" , (this.inputForm.email != null || this.inputForm.email != '') ?this.inputForm.email :'Pugindo@gmail.com')
            
            this.isSubmitting = true

            this.$axios.post('nasabah/rekening', payload, { timeout: 300000 }).then(() => {
            this.$bvModal.hide("modal-tambah-rek")
            this.$bvModal.hide("modal-confirm-input")
            this.inputForm.anBank = null
            this.inputForm.noRek = null
            this.inputForm.bank = null
            this.$emit('getEmail' ,(this.inputForm.email != null || this.inputForm.email != '') ?this.inputForm.email :'Pugindo@gmail.com')
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.submit = true
                this.getRekening()
            })

        },
        onSubmitEdit(){
            let payload = new FormData
            payload.append("idRekening" , this.inputForm.id )
            payload.append("namaRekening" , this.inputForm.anBank )
            payload.append("noRekening" , this.inputForm.noRek )
            payload.append("bank" , this.inputForm.bank.id )
            payload.append("nasabah" , this.id )
            payload.append("email" , (this.inputForm.email != null || this.inputForm.email != '') ?this.inputForm.email :'Pugindo@gmail.com')
            
            let id = this.inputForm.id
            this.isSubmitting = true

            this.$axios.post('nasabah/rekening', payload, { timeout: 300000 }).then(() => {
            this.$bvModal.hide("modal-edit-rek")
            this.$bvModal.hide("modal-confirm-edit-rekening")
            this.inputForm.id = null
            this.inputForm.anBank = null
            this.inputForm.noRek = null
            this.inputForm.bank = null
            this.$emit('getEmail' ,(this.inputForm.email != null || this.inputForm.email != '') ?this.inputForm.email :'Pugindo@gmail.com')
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.submit = true
                this.pending(id)
                this.getRekening()
            })

        },
        pending(id){
            let payload = new FormData
            payload.append("idRekening" , id )
            payload.append("status" , 2 )
            this.$axios.post('/nasabah/rekening/approve', payload).then(() => {

            }) .catch(error => {
                console.log(error)
            })
        },
        approveEditRekening(){
            let payload = new FormData
            payload.append("idRekening" , this.activeId )
            payload.append("status" , 1 )
            this.$axios.post('/nasabah/rekening/approve', payload).then(() => {

                this.$bvModal.hide("modal-approve-edit")
                this.getRekening()
                this.$helper.toastSucc(this, "No. Rekening Berhasil Diubah")
            }) .catch(error => {
                console.log(error)
            })
        },
        showModalInput(){
            this.inputForm.bank = null
            this.inputForm.noRek = null
            this.inputForm.anBank = null
            this.$bvModal.show("modal-tambah-rek")
        },
        showModalAktif(id){
            this.activeId = id
            this.$bvModal.show("modal-aktif")
        },
        showModalEdit(item){
            let bank = item.namaBank
            let idx = this.optionsBank.findIndex(item => item.name == bank)
            // this.anggota.rekening.findIndex(item => item.id == idRekening)
            this.inputForm.id = item.id
            this.inputForm.bank = this.optionsBank[idx]
            this.inputForm.noRek = item.noRekening
            this.inputForm.anBank = item.namaRekening
            this.inputForm.email = item.email
            this.$bvModal.show("modal-edit-rek")
        },

        showModalNonAktif(id){
            this.activeId = id
            this.$bvModal.show("modal-non-aktif")
        },

        showApproveEdit(id){
            this.activeId = id
            this.$bvModal.show("modal-approve-edit")
        },

        aktif(){
            let payload = new FormData
            payload.append("idRekening" , this.activeId)
            payload.append("status" , 1)
            this.toggleBusy()
            this.$axios.post('nasabah/rekening/approve' , payload ).then(() => {
                this.$bvModal.hide("modal-aktif")
                this.getRekening()
                this.$helper.toastSucc(this, "No. Rekening Berhasil Diaktifkan")
            }).catch(error => {
                console.log(error)
            })
        },

        nonAktif(){
            let payload = new FormData
            payload.append("idRekening" , this.activeId)
            payload.append("status" , 0)
            this.toggleBusy()
            this.$axios.post('nasabah/rekening/approve' , payload ).then(() => {
                this.$bvModal.hide("modal-non-aktif")
                this.getRekening()
                this.$helper.toastSucc(this, "No. Rekening Berhasil Dinon-aktifkan")
            }).catch(error => {
                console.log(error)
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        updateTotalItem(){
            this.perPage = this.input.show
            this.rows = this.rekening.length
           
            if (this.perPage > this.rows){
               
                this.perPage = this.rows
            }
         
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },


        },

        created(){
            this.init()
        },
    }
</script>